
if($('#job-search-form-object').length) {

    let initialSearchDone = false,
        sitename = 'Staff Management'
        keywords = [],
        page = 1,
        lastSearchQuery = '',
        lastSearchLocation = '',
        selectedCountry = '',
        selectedState = '',
        selectedCity = '',
        selectedZip = '',
        selectedDistance = '',
        selectedCategory = '',
        selectedEmploymentType = '',
        sortDirection = 'desc',
        sortToggle = $('#sort-date-toggle'),
        searchForm = $('#job-search-form-object'),
        locationInput = $('#job-search-location'),
        keywordInput = $('#job-search-keyword'),
        newKeywordInput = $('#add-keywords-input'),
        newKeywordButton = $('#add-keywords-button'),
        distanceInput = $('#job-search-distance'),
        filterSubmitButton = $('#job-search-submit-button'),
        resetFiltersButton = $('#job-search-reset-filters'),
        mobileFiltersButton = $('#filters-button-mobile'),
        mobileFiltersCloseButton = $('#mobile-close-filters-button'),
        employmentTypeSelect = $('#employment_type'),
        filtersContainer = $('.job-search-left'),
        shareToggle = $('#filters-share-toggle'),
        shareContainer = $('.filters-share-container');

    $(document).on('click', '.result-item', function() {
        let jobCode = $(this).data('job-code'),
            mediaCode = $(this).data('media-code');

        if(jobCode && mediaCode) {
            window.location.href = '/listing?jobCode=' + encodeURIComponent(jobCode) + '&mediaCode=' + encodeURIComponent(mediaCode);
        } else if(jobCode) {
            window.location.href = '/listing?jobCode=' + encodeURIComponent(jobCode);
        }
    });

    shareToggle.on('click', function() {
        shareContainer.slideToggle();
    });

    categorySelectValues();

    function categorySelectValues() {
        $.post('/wp-admin/admin-ajax.php', {
            action: 'category_select',
            // category: GetURLParameter('category')
        }, function(response) {
            let val = response.data;
            $('#category').html(val.category);
            initialRun();
        });
    }

    employmentTypeSelect.select2({
        placeholder: "Employment Type",
        allowClear: true,
        width: '100%',
        dropdownCssClass : "filter-select",
        minimumResultsForSearch: Infinity
    });

    $('#category').select2({
        placeholder: 'Job Category',
        minimumResultsForSearch: Infinity,
        allowClear: true,
        dropdownCssClass : "filter-select",

        width: '100%'
    });

    $('#country').select2({
        placeholder: "Country",
        allowClear: true,
        width: '100%',
        dropdownCssClass : "filter-select",
        minimumResultsForSearch: Infinity
    });

    $("#country").on("change", function() {
        $('#city').val('').trigger('keyup');
        $('#zip').val('').trigger('keyup');
        if ($(this).val() == 'US') {
            $('#state').select2();
            $('#state').select2("destroy");
            $('#state').select2({
                dropdownCssClass : "filter-select",
                placeholder: 'Select State',
                width: '100%',
                allowClear: true
            });
            $('#state').html('<option aria-label="Select a Value"></option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option>').change()
            $('#zip').attr('placeholder', 'Zip');
            $('#zip').attr('maxlength', '5');
            $('#city').parent().parent().show();
            $('#state').parent().show();
            $('#zip').parent().parent().show();
        } else if ($(this).val() == 'CA') {
            $('#state').select2();
            $('#state').select2("destroy");
            $('#state').select2({
                dropdownCssClass : "filter-select",
                placeholder: 'Select Province',
                width: '100%',
                allowClear: true
            });
            $('#state').html('<option aria-label="Select a Value"></option><option value="AB">Alberta</option><option value="BC">British Columbia</option><option value="MB">Manitoba</option><option value="NB">New Brunswick</option><option value="NL">Newfoundland and Labrador</option><option value="NS">Nova Scotia</option><option value="ON">Ontario</option><option value="PE">Prince Edward Island</option><option value="QC">Quebec</option><option value="SK">Saskatchewan</option><option value="NT">Northwest Territories</option><option value="NU">Nunavut</option><option value="YT">Yukon</option>').change()
            $('#zip').attr('placeholder', 'Postal Code');
            $('#zip').attr('maxlength', '');
            // var newURL = updateURLParameter(window.location.href, 'state', '');
            // newURL = updateURLParameter(window.location.href, 'city', '');
            // newURL = updateURLParameter(window.location.href, 'zip', '');
            // newURL = updateURLParameter(newURL, 'country', '');
            // newURL = updateURLParameter(newURL, 'loc', '');
            $('#city').parent().parent().show();
            $('#state').parent().show();
            $('#zip').parent().parent().show();
        } else {
            $('#state').select2();
            $('#state').select2("destroy");
            $('#state').select2({
                dropdownCssClass : "filter-select",
                placeholder: 'Select State',
                width: '100%',
                allowClear: true
            });
            $('#state').html('<option aria-label="Select a Value"></option><option value="AL">Alabama</option><option value="AK">Alaska</option><option value="AZ">Arizona</option><option value="AR">Arkansas</option><option value="CA">California</option><option value="CO">Colorado</option><option value="CT">Connecticut</option><option value="DE">Delaware</option><option value="DC">District Of Columbia</option><option value="FL">Florida</option><option value="GA">Georgia</option><option value="HI">Hawaii</option><option value="ID">Idaho</option><option value="IL">Illinois</option><option value="IN">Indiana</option><option value="IA">Iowa</option><option value="KS">Kansas</option><option value="KY">Kentucky</option><option value="LA">Louisiana</option><option value="ME">Maine</option><option value="MD">Maryland</option><option value="MA">Massachusetts</option><option value="MI">Michigan</option><option value="MN">Minnesota</option><option value="MS">Mississippi</option><option value="MO">Missouri</option><option value="MT">Montana</option><option value="NE">Nebraska</option><option value="NV">Nevada</option><option value="NH">New Hampshire</option><option value="NJ">New Jersey</option><option value="NM">New Mexico</option><option value="NY">New York</option><option value="NC">North Carolina</option><option value="ND">North Dakota</option><option value="OH">Ohio</option><option value="OK">Oklahoma</option><option value="OR">Oregon</option><option value="PA">Pennsylvania</option><option value="RI">Rhode Island</option><option value="SC">South Carolina</option><option value="SD">South Dakota</option><option value="TN">Tennessee</option><option value="TX">Texas</option><option value="UT">Utah</option><option value="VT">Vermont</option><option value="VA">Virginia</option><option value="WA">Washington</option><option value="WV">West Virginia</option><option value="WI">Wisconsin</option><option value="WY">Wyoming</option><option value="AB">Alberta</option><option value="BC">British Columbia</option><option value="MB">Manitoba</option><option value="NB">New Brunswick</option><option value="NL">Newfoundland and Labrador</option><option value="NS">Nova Scotia</option><option value="ON">Ontario</option><option value="PE">Prince Edward Island</option><option value="QC">Quebec</option><option value="SK">Saskatchewan</option><option value="NT">Northwest Territories</option><option value="NU">Nunavut</option><option value="YT">Yukon</option>').change()
            $('#zip').attr('placeholder', 'Zip');
            $('#zip').attr('maxlength', '5');
            $('#city').parent().parent().hide();
            $('#state').parent().hide();
            $('#zip').parent().parent().hide();
        }

    });

    $('#state').select2({
        placeholder: "State",
        allowClear: true,
        width: '100%',
        dropdownCssClass : "filter-select",
        // minimumResultsForSearch: Infinity
    });

    mobileFiltersButton.on('click', function() {
        filtersContainer.fadeIn();
    });

    mobileFiltersCloseButton.on('click', function() {
        filtersContainer.fadeOut();
    });

    sortToggle.on('click', function() {
        if(sortDirection === 'desc') {
            sortDirection = 'asc';
            sortToggle.removeClass('sort-desc').addClass('sort-asc');
        } else {
            sortDirection = 'desc';
            sortToggle.removeClass('sort-asc').addClass('sort-desc');
        }
        searchJobs();
    });

    resetFiltersButton.on('click', function(e) {
        resetFilters();
        searchJobs();
    });

    function resetFilters() {
        keywords = [];
        lastSearchQuery = '';
        lastSearchLocation = '';
        selectedCountry = '';
        selectedState = '';
        selectedCity = '';
        selectedZip = '';
        selectedDistance = '';
        selectedCategory = '';
        selectedEmploymentType = '';
        page = 1;
        sortDirection = 'desc';

        sortToggle.removeClass('sort-asc').addClass('sort-desc');
        employmentTypeSelect.val(null).trigger('change');
        $('#category').val(null).trigger('change');
        $('#country').val(null).trigger('change');
        $('#state').val(null).trigger('change');
        $('#city').val('');
        $('#zip').val('');

        locationInput.val('');
        keywordInput.val('');
        newKeywordInput.val('');
        distanceInput.val(30);
        $('.distance-value').text('30');
        $('#job-search-category').val('');
        processSelectedKeywords();
    }

    filterSubmitButton.on('click', function(e) {
        e.preventDefault();
        searchJobs();
        if($(window).width() < 992) {
            filtersContainer.fadeOut();
        }
    });

    searchForm.on('submit', function(e) {
        e.preventDefault();
        searchJobs();
    });

    newKeywordButton.on('click', function() {
        let newKeyword = newKeywordInput.val().trim();
        if(newKeyword && !keywords.includes(newKeyword)) {
            keywords.push(newKeyword);
            processSelectedKeywords();
            newKeywordInput.val('');
            searchJobs();
        }
    });

    newKeywordInput.on('keypress', function(e) {
        if(e.which === 13) { // Enter key
            e.preventDefault();
            newKeywordButton.click();
        }
    });

    function processSelectedKeywords() {
        let html = '';
        keywords.forEach(function(item, index) {
            html += '<button class="remove-keyword" data-index="' + index + '">' + item + ' <span class="remove-icon">' +
                '<svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                '<rect x="2.45312" y="0.83252" width="30" height="3" transform="rotate(45 2.45312 0.83252)" fill="#fff"/>' +
                '<rect x="0.332031" y="22.0459" width="30" height="3" transform="rotate(-45 0.332031 22.0459)" fill="#fff"/>' +
                '</svg></span></button>';
        });
        $('.selected-keywords').html(html);
    }

    $(document).on('click', '.remove-keyword', function() {
        let index = $(this).data('index'),
            keyword = keywords[index];

        if(keyword === keywordInput.val().trim()) {
            keywordInput.val('');
        }

        keywords.splice(index, 1);
        processSelectedKeywords();
        searchJobs();
    });

    distanceInput.on('change', function() {
        $('.distance-value').text($(this).val());
        selectedDistance = $(this).val();
        searchJobs();
    });



    // Pagination Controls
    $(document).on('click', '.results-pagination-container a', function(e) {
        e.preventDefault();
        page = $(this).attr('data-href');
        if(!page || page == 0) {
            page = 1;
        }
        searchJobs();
    });


    var detailsBox = document.getElementById('details-box');

    document.addEventListener('mouseover', function (e) {
        if (e.target.tagName == 'path') {
            var content = e.target.dataset.name;
            detailsBox.innerHTML = content;
            detailsBox.style.opacity = "100%";
        }
        else {
            detailsBox.style.opacity = "0%";
        }
    });

    // Add click functionality
    document.addEventListener('click', function (e) {
        if (e.target.tagName === 'path') {
            let provinceLabel = $(e.target).parent().data('label');
            if(provinceLabel && provinceLabel.length) {
                $('#country').val('CA').trigger('change');
                let stateOption = $('#state option').filter(function() {
                    return $(this).text() === provinceLabel;
                });
                if(stateOption.length) {
                    $('#state').val(stateOption.val()).trigger('change');
                    searchJobs();
                }
            } else {
                var stateName = e.target.dataset.name;
                if (stateName) {
                    let stateOption = $('#state option').filter(function() {
                        return $(this).text() === stateName;
                    });
                    $('#country').val('US').trigger('change');
                    if(stateOption.length) {
                        $('#state').val(stateOption.val()).trigger('change');
                        searchJobs();
                    }
                }
            }
        }
    });

    window.onmousemove = function (e) {
        var x = e.clientX,
            y = e.clientY;
        detailsBox.style.top = (y + 20) + 'px';
        detailsBox.style.left = (x) + 'px';
    };

//ADD NAME TO EACH STATE
    /*
    document.addEventListener("DOMContentLoaded", () => {
      const statePaths = document.querySelectorAll("path");

      statePaths.forEach((state) => {
        const stateName = state.dataset.name;
        if (stateName) {
          // Create a <text> element
          const textElement = document.createElementNS("http://www.w3.org/2000/svg", "text");
          textElement.setAttribute("x", state.getBBox().x + state.getBBox().width / 2); // Center the text
          textElement.setAttribute("y", state.getBBox().y + state.getBBox().height / 2);
          textElement.setAttribute("font-size", "10");
          textElement.setAttribute("fill", "black");
          textElement.setAttribute("text-anchor", "middle"); // Center align the text
          textElement.textContent = stateName;

          // Append the <text> to the SVG
          state.parentNode.appendChild(textElement);
        }
      });
    });
    */
    let usMapButton = $('#toggle-us-map'),
        canadaMapButton = $('#toggle-canada-map'),
        usMap = $('#us-map'),
        canadaMap = $('#canada-map'),
        topContainer = $('.top-container'),
        mapSearchContainer = $('#map-search-container'),
        keywordSearchContainer = $('#keyword-search-container'),
        toggleKeywordSearchButton = $('#toggle-keyword-search'),
        toggleMapSearchButton = $('#toggle-map-search');

    toggleKeywordSearchButton.on('click', function() {
        mapSearchContainer.fadeOut(300);
        setTimeout(function () {
            keywordSearchContainer.fadeIn(300);
        }, 300);
        toggleKeywordSearchButton.addClass('active');
        toggleMapSearchButton.removeClass('active');
        topContainer.addClass('searching-keyword').removeClass('searching-map');
    });

    toggleMapSearchButton.on('click', function() {
        keywordSearchContainer.fadeOut(300);
        setTimeout(function () {
            mapSearchContainer.fadeIn(300);
        }, 300);
        toggleMapSearchButton.addClass('active');
        toggleKeywordSearchButton.removeClass('active');
        topContainer.addClass('searching-map').removeClass('searching-keyword');
    });


    usMapButton.on('click', function() {
        canadaMap.fadeOut(300);
        setTimeout(function () {
            usMap.fadeIn(300);
        }, 300);
        usMapButton.addClass('active');
        canadaMapButton.removeClass('active');
    });

    canadaMapButton.on('click', function() {
        usMap.fadeOut(300);
        setTimeout(function () {
            canadaMap.fadeIn(300);
        }, 300);
        usMapButton.removeClass('active');
        canadaMapButton.addClass('active');
    });

    function processUrlParams() {

        if(GetURLParameter('category')) {
            $('#category').val(GetURLParameter('category')).trigger('change');
        }

        if(GetURLParameter('country')) {
            $('#country').val(GetURLParameter('country')).trigger('change');
        }

        if(GetURLParameter('state')) {
            let stateOption = $('#state option').filter(function() {
                if($(this).text() === GetURLParameter('state') || $(this).val() === GetURLParameter('state')) {
                    return true;
                }
            });
            if(stateOption.length) {
                $('#state').val(stateOption.val()).trigger('change');
            }
        }

        if(GetURLParameter('city')) {
            $('#city').val(GetURLParameter('city'));
        }

        if(GetURLParameter('zip')) {
            $('#zip').val(GetURLParameter('zip'));
        }

        if(GetURLParameter('distance')) {
            distanceInput.val(GetURLParameter('distance'));
            $('.distance-value').text(GetURLParameter('distance'));
        }

        if(GetURLParameter('keyword')) {
            let urlKeywords = decodeURIComponent(GetURLParameter('keyword')).split(',');
            urlKeywords = urlKeywords.filter(function(kw) {
                return kw && kw.toLowerCase() !== 'undefined';
            });
            keywords = urlKeywords;
            processSelectedKeywords();
        }

        if(GetURLParameter('empType')) {
            employmentTypeSelect.val(GetURLParameter('empType')).trigger('change');
        }

    }

    function resetUrlParams() {
        let newURL = updateURLParameter(newURL, 'category', '');
        newURL = updateURLParameter(newURL, 'country', '');
        newURL = updateURLParameter(newURL, 'state', '');
        newURL = updateURLParameter(newURL, 'city', '');
        newURL = updateURLParameter(newURL, 'zip', '');
        newURL = updateURLParameter(newURL, 'distance', '');
        newURL = updateURLParameter(newURL, 'keyword', '');
        newURL = updateURLParameter(newURL, 'empType', '');
        newURL = updateURLParameter(newURL, 'sortBy', '');
        newURL = updateURLParameter(newURL, 'sortOrder', '');
        newURL = updateURLParameter(newURL, 'loc', '');

        // Update the URL:
        update_url(newURL);
    }

    function GetURLParameter(sParam) {
        var sPageURL = window.location.search.substring(1);
        var sURLVariables = sPageURL.split('&');
        for (var i = 0; i < sURLVariables.length; i++) {
            var sParameterName = sURLVariables[i].split('=');
            if (sParameterName[0] == sParam) {
                if(sParameterName[1] === undefined || sParameterName[1].toLowerCase() === 'undefined' || sParameterName[1].toLowerCase() === 'null' || sParameterName[1].trim() === '') {
                    return '';
                }
                return decodeURIComponent(sParameterName[1]);
            }
        }
    }

    function updateURLParameter(url, param, paramVal){

        if(!url) return '';

        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";
        if (additionalURL) {
            tempArray = additionalURL.split("&");
            for (var i=0; i<tempArray.length; i++){
                if(tempArray[i].split('=')[0] != param){
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        }
        var rows_txt = temp + "" + param + "=" + encodeURIComponent(paramVal);
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }

    function update_url(newURL){
        newURL = newURL.replaceAll('%25', '%');
        window.history.pushState({"html": "search", "pageTitle": "Search -“ "+sitename}, "Search - "+sitename, newURL);
    }

    function searchJobs() {

        $('.loader').removeClass('hidden');

        if(keywordInput.val() !== lastSearchQuery) {
            keywords = [];
            if (keywordInput.val().trim() !== '') {
                keywords.push(keywordInput.val().trim());
            }
            page = 1;
            processSelectedKeywords();
        }

        if(!keywords.length) {
            if(keywordInput.val().trim() !== '') {
                keywords.push(keywordInput.val().trim());
            }
        }

        if(locationInput.val().trim() === '' && lastSearchLocation.length) {
            $('#country').val('').trigger('change');
            $('#state').val('').trigger('change');
            $('#city').val('');
            $('#zip').val('');
            page = 1;
            resetUrlParams();
        }

        if(locationInput.val().trim() !== lastSearchLocation) {
            page = 1;
        }

        lastSearchLocation = locationInput.val();

        let cleanedKeywords = encodeURIComponent(keywords.join(','));

        lastSearchQuery = keywordInput.val();

        selectedCountry = $('#country').val();
        selectedState = $('#state').val();
        selectedCity = $('#city').val().trim();
        selectedZip = $('#zip').val().trim();
        selectedDistance = distanceInput.val();
        selectedCategory = $('#category').val();
        selectedEmploymentType = employmentTypeSelect.val();
        if(!selectedDistance) {
            selectedDistance = 30;
        }
        if(!page) {
            page = 1;
        }
        if(!sortDirection) {
            sortDirection = 'desc';
        }

        // update the URL parameters

        // console.log({
        //     action: 'job_search',
        //     page: page,
        //     loc: locationInput.val(),
        //     sortOrder: sortDirection,
        //     nonce: window.job_search_nonce,
        //     keyword: cleanedKeywords,
        //     country: selectedCountry,
        //     state: selectedState,
        //     city: selectedCity,
        //     zip: selectedZip,
        //     distance: selectedDistance,
        //     category: selectedCategory,
        // });
        let newURL = window.location.href;
        newURL = updateURLParameter(newURL, 'category', selectedCategory);
        newURL = updateURLParameter(newURL, 'country', selectedCountry);
        newURL = updateURLParameter(newURL, 'state', selectedState);
        newURL = updateURLParameter(newURL, 'city', selectedCity);
        newURL = updateURLParameter(newURL, 'zip', selectedZip);
        newURL = updateURLParameter(newURL, 'distance', selectedDistance);
        newURL = updateURLParameter(newURL, 'keyword', cleanedKeywords);
        newURL = updateURLParameter(newURL, 'empType', selectedEmploymentType);
        newURL = updateURLParameter(newURL, 'sortOrder', sortDirection);
        update_url(newURL);


        $.post('/wp-admin/admin-ajax.php', {
            action: 'job_search',
            page: page,
            sortOrder: sortDirection,
            nonce: window.job_search_nonce,
            loc: locationInput.val(),
            keyword: cleanedKeywords,
            country: selectedCountry,
            state: selectedState,
            city: selectedCity,
            zip: selectedZip,
            distance: selectedDistance,
            categoryId: selectedCategory,
            empType: selectedEmploymentType
        }, function(response) {
            if(response.data.postings === "NO RESULTS") {
                $('#job-search-results').html('');
                $('.no-results-container').removeClass('hidden');
            } else {
                $('#job-search-results').html(response.data.postings);
                $('.no-results-container').addClass('hidden');
            }
            $('.results-pagination-container').html(response.data.pagination);
            $('.search-currently-showing').text(response.data.count_on_page);
            $('.search-total-results').text(response.data.total_job_count);

            $('.loader').addClass('hidden');

            if(typeof response.data.loc === 'object') {
                let stateOption = null;
                let newURL = window.location.href;
                if(response.data?.loc?.country) {
                    $('#country').val(response.data.loc.country).trigger('change');
                    newURL = updateURLParameter(newURL, 'country', response.data.loc.country);
                }
                if(response.data?.loc?.state) {
                    stateOption = $('#state option').filter(function() {
                        if($(this).text() === response.data.loc.state) {
                            $('#state').val($(this).val()).trigger('change');
                            newURL = updateURLParameter(newURL, 'state', $(this).val());
                            return true;
                        }
                    });
                }
                if(response.data?.loc?.city) {
                    $('#city').val(response.data.loc.city);
                    newURL = updateURLParameter(newURL, 'city', response.data.loc.city);
                }
                if(response.data?.loc?.zip) {
                    $('#zip').val(response.data.loc.zip);
                    newURL = updateURLParameter(newURL, 'zip', response.data.loc.zip);
                }

                let searchLoc = '';
                if(response.data?.loc?.city) {
                    searchLoc += response.data.loc.city;
                }
                if(response.data?.loc?.state && stateOption.val()) {
                    if(searchLoc.length) searchLoc += ', ';
                    searchLoc += stateOption.text();
                }
                if(response.data?.loc?.country) {
                    if(searchLoc.length) searchLoc += ', ';
                    searchLoc += response.data.loc.country;
                }

                locationInput.val(searchLoc);

                update_url(newURL);
            }

            if(initialSearchDone) {
                // scroll nicely to .job-search-inner
                $('html, body').animate({
                    scrollTop: $(".job-search-inner").offset().top
                }, 500);
            }

            initialSearchDone = true;
        });

    }

    function initialRun() {
        processSelectedKeywords();
        processUrlParams();
        searchJobs();
    }

}
